export default __webpack_public_path__ + "static/media/cert-general2024-HKIRC.0bff374f.jpg";